import { Link } from "react-router-dom";
import "./Privacy.css";

export const Privacy = () => {
    return (
        <div className="privacy-wrapper">
            <div className="privacy-container">
                <div className="privacy-left-section">
                    <h1 className="privacy-main-heading">
                        <span>Privacy</span>
                        <span>Policy</span>
                    </h1>
                    <div className="privacy-divider-line"></div>
                </div>
                <div className="privacy-right-section">
                    <div className="privacy-logo">
                        <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="92"
                            height="111"
                            viewBox="0 0 92 111"
                            fill="none"
                        >
                            <path
                                d="M65.4449 25.611L75.117 31.0505L50.6292 46.851V58.7662L91.9986 34.7804V27.3284L45.6862 0L0 27.9583V41.6158L45.9926 14.2874L54.946 19.3945L0 53.0676V66.5369L65.4449 25.611Z"
                                fill="#00151F"
                            />
                            <path
                                d="M15.0243 80.8149L41.3708 63.7193L41.3708 51.8042L0.00140662 78.3801L0.00140597 85.8322L46.3138 110.57L92 82.612L92 68.9545L92 47.9188L82.8886 53.2288L82.8886 73.8212L46.0074 96.2829L15.0243 80.8149Z"
                                fill="#50A854"
                            />
                        </svg>
                    </div>
                    <div className="privacy-content-wrapper">
                        <div className="privacy-content">
                            <div className="privacy-item">
                                <p className="privacy-paragraph">
                                    MedRPT LLC is committed to protecting the privacy of its users. Information gathered by MedRPT LLC is used to monitor our effectiveness in providing relevant and credible medical information, in answering your questions and in improving the site.
                                </p>
                                <p className="privacy-paragraph">
                                    The best way to contact us is by e-mail at{" "}
                                    <a className="privacy-email" href="mailto:info@medrpt.ai">info@medrpt.ai</a>.
                                </p>
                            </div>

                            <div className="privacy-item">
                                <h2 className="privacy-heading">What We Collect</h2>
                                <p className="privacy-paragraph">
                                    When you visit MedRPT LLC, our server will recognize and collect, if possible, the domain name of your e-mail address (for example, anywhere.com) but our software will not, automatically, record your complete e-mail address. From the registration data, we will collect your e-mail address and payment information, which is managed and stored by Stripe. If you do not register, the only way we can know your complete e-mail address is if you provide it on a survey or feedback form.
                                </p>
                            </div>


                            <div className="privacy-item">
                                <h2 className="privacy-heading">What We Do With Your Information</h2>
                                <p className="privacy-paragraph">
                                    MedRPT LLC will aggregate all domain information so that we can calculate the number of visitors to MedRPT LLC each day. Any other information you have given us will never be sold, traded or rented to any third party without your prior approval. Moreover, no business partners of the Company or third parties will be allowed to have access to your data under any circumstances without your prior approval. In the unlikely event that the Company is ordered by a judicial or law enforcement body to provide such information, we will disclose the requested information. In that instance, unless prohibited by the requesting authorities, we will inform you of the official request.
                                </p>
                            </div>


                            <div className="privacy-item">
                                <h2 className="privacy-heading">How We Will Safeguard Your Information</h2>
                                <p className="privacy-paragraph">
                                    Member data are stored on a secure server, cannot be accessed via the website and will never be released without your permission. A restricted number of Company employees will have access to the data for internal data maintenance purposes.
                                </p>
                            </div>


                            <div className="privacy-item">
                                <h2 className="privacy-heading">How Can I Unsubscribe or Change My Information?</h2>
                                <p className="privacy-paragraph">
                                    If you no longer wish to receive e-mail from MedRPT LLC, please visit the{" "}
                                    <Link to="/settings" className="privacy-link">Settings page</Link> where you can update your registration information and email preferences. To unsubscribe from our emails, click the “Stop receiving emails” button. Please note that selecting this option will stop all scheduled email updates related to any questions or concerns you have submitted. If you have more than one account you will need to do this for each.
                                </p>
                            </div>


                            <div className="privacy-item">
                                <h2 className="privacy-heading">Do We Track "Cookies"?</h2>
                                <p className="privacy-paragraph">
                                    "Cookies" are information packets that your browser records and saves on your computer's hard drive. MedRPT LLC does not use cookies to track information.
                                </p>
                            </div>


                            <div className="privacy-item">
                                <h2 className="privacy-heading">Your Agreement</h2>
                                <p className="privacy-paragraph">
                                    By using our website, you consent to the collection and use of the information discussed above by MedRPT LLC. We welcome your questions and comments about privacy. Please send e-mail to{" "}
                                    <a className="privacy-email" href="mailto:info@medrpt.ai">info@medrpt.ai</a>.
                                </p>
                            </div>


                            <div className="privacy-item">
                                <p className="privacy-date">Updated on January 22, 2026</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
